/* PravaahLogo — single source of truth for the Pravaah brand image.

   Two transparent PNG variants live in /public:
   - light  → "PR" rendered in WHITE (use on DARK backgrounds: sidebars, login hero)
   - dark   → "PR" rendered in BLACK (use on LIGHT backgrounds: mobile login, white cards)

   Each variant has a wide horizontal version + a square padded version.

   Props:
     theme    "light" (default, white-PR for dark bg) | "dark" (black-PR for light bg)
     variant  "full" wide horizontal | "badge" square
*/
const ASSETS = {
  light: { wide: "/pravaah-logo-light.png",  square: "/pravaah-logo-light-square.png",  ratio: 3.66 },
  dark:  { wide: "/pravaah-logo-dark.png",   square: "/pravaah-logo-dark-square.png",   ratio: 3.00 },
};

export const PravaahLogo = ({
  variant = "full",
  theme = "light",
  className = "",
  size,
  dataTestId = "pravaah-logo",
}) => {
  const asset = ASSETS[theme] || ASSETS.light;
  if (variant === "badge") {
    const dim = size || 40;
    return (
      <img
        src={asset.square}
        alt="Pravaah"
        width={dim}
        height={dim}
        className={`shrink-0 ${className}`}
        style={{ width: dim, height: dim, objectFit: "contain" }}
        data-testid={dataTestId}
      />
    );
  }
  // Full word-mark — height-driven, width derived from the asset's intrinsic ratio.
  const h = size || 40;
  const w = h * asset.ratio;
  return (
    <img
      src={asset.wide}
      alt="Pravaah by Avi Cement Limited"
      style={{ height: h, width: w, objectFit: "contain" }}
      className={className}
      data-testid={dataTestId}
    />
  );
};

export default PravaahLogo;






